
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  getDisplayName, getuserCurrentApp,
  getToken
} from '@/utils/cookies.ts'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { CONFIGAPI } from '@/api/config'
import { isAgentMobile } from '@/utils/validate'
import { ConfigModule } from '@/store/modules/config'
import { CGGLISISSUESAPI, baseURL } from '@/api/cggl'

console.log(baseURL + 'xa', 55)

@Component({
  components: {
    VuePicker
  }
})
export default class AppMain extends Vue {
  @Prop({ default: false }) private editForm!: any; // 编辑表单时用到的表单数据
  private editId = 0;
  private isDisableSubmit = false; // 避免重复触发提交按钮
  private locationOptions = []; // 所在地区options
  // 联动下拉框手机端
  private pickerLocationVisible = false; // 点击所在地区文本框，显示picker联动
  private defaultIssueIndex = [] as number[]; // 默认联动定位，从0开始，0代表第一行
  private liveIssueCn = ''; // 移动端：所在地区内容

  formData = {
    tutorName: this.username,
    issueDate: new Date(),
    location: [] as any,
    position: '',
    describe: '',
    remark: '',
    // problem_type: [] as any,
    fileList: [] as Array<{ image_url: string; name: string }>
  };

  formRules: object = {
    tutorName: [{ required: true }],
    issueDate: [{ required: true }],
    location: [
      { required: true, message: '请选择所在地区', trigger: 'change' }
    ],
    // problem_type: [
    //   { required: true, message: '请选择问题类型', trigger: 'change' }
    // ],
    position: [{ required: true, message: '请准确描述您的位置', trigger: 'blur' }],
    describe: [
      {
        required: true,
        message: '表扬/咨询/报修/建议，请详细描述您的问题',
        trigger: 'blur',
        min: 1
      }
    ]
  };

  pickerOptions: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  get uploadImgUrl() {
    return baseURL + 'xz/uploadImage'
  }

  get getToken() {
    return getToken
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  get isEdit() {
    return !!this.editForm
  }

  get isAgentMobile() {
    return isAgentMobile()
  }

  // 工单类型
  get ticketType() {
    if (this.isEdit) {
      return this.editForm.ticket_type
    }
    return this.$route.name === 'tutor' ? 2 : 3
  }

  // 标题
  get formTitle() {
    let title = '行政'
    // title += this.ticketType === 2 ? '班主任' : 'LP(学规)'
    title += this.isEdit ? '工单编辑' : '工单录入'
    return title
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get username() {
    return getDisplayName()
  }

  mounted() {
    this.getTutorLocation() // 获取班主任所在地区列表
    this.getTutorIssueType()
    // 编辑时location值设置
    if (this.isEdit) {
      this.assignFormdata()
      this.handleChangeLocation(this.formData.location)
    }
  }

  private handleChangeLocation(value: any) {
    console.log('下拉菜单改变')
  }

  // 判断是否是创建人，受理人列表中禁用掉创建人
  private isCreater(item: any) {
    return item.workcode === UserModule.workcode
  }

  private issueTypeOptions = []; // 问题类型options
  private pickerIssueVisible = false; // 点击问题类型文本框，显示picker联动
  private issueTypeCn = ''; // 移动端：问题类型内容

  // 获取问题类型
  private async getTutorIssueType() {
    const options = ConfigModule.issueTypeOptions
    if (options.length <= 0) {
      // 仅首次打开时请求
      const { data } = await CONFIGAPI.getIssuesType({
        app_id: this.userCurrentApp
      })
      const newData: any = []
      // 删掉掉没有基地的地区
      data.map((item: any) => {
        if (item.children && item.children.length !== 0) {
          newData.push(item)
        }
      })
      this.issueTypeOptions = newData
      ConfigModule.setIssueTypeOptions(newData)
    } else {
      this.issueTypeOptions = options
    }
  }

  // 获取班主任所在地区列表
  private async getTutorLocation() {
    const { data } = await CONFIGAPI.getLocation({
      app_id: this.userCurrentApp
    })
    let newData: any = []
    // 删掉掉没有基地的地区，移除转接虚拟基地
    data.map((item: any) => {
      if (
        item.children &&
        item.children.length !== 0 &&
        item.label.indexOf('转接') === -1
      ) {
        newData.push(item)
      }
    })
    if (this.classObj.mobile) {
      // 手机端插件数据结构需要用value
      newData = JSON.parse(JSON.stringify(newData).replace(/"id"/g, '"value"'))
    }
    this.locationOptions = newData
    const locationValues: any = []
    // 移动端：编辑时定位直播间级联的默认位置
    if (this.classObj.mobile && this.isEdit) {
      this.locationOptions.some((parent: any, index1: number) => {
        if (parent.value === this.editForm.location.place_id) {
          parent.children.some((building: any, index2: number) => {
            if (building.value === this.editForm.location.building_id) {
              building.children.some((item: any, index3: number) => {
                if (item.value === this.editForm.location.floor_id) {
                  locationValues.push([
                    parent.label,
                    building.label,
                    item.label
                  ])
                  this.defaultIssueIndex = [index1, index2, index3]
                }
              })
            }
          })
        }
      })
    }
  }

  // 移动端：所在地区联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.liveIssueCn = issueType.join('/')
    this.formData.location = [
      res[0].value || res[0].id,
      res[1].value || res[1].id,
      res[2] ? res[2].value || res[2].id : ''
    ]
  }

  // confirmChangeIssueType(res: any) {
  //   const issueType: string[] = []
  //   res.map((item: { label: string }) => {
  //     issueType.push(item.label)
  //   })
  //   this.issueTypeCn = issueType.join('/')
  //   this.formData.problem_type = [
  //     res[0].value || res[0].id,
  //     res[1].value || res[1].id,
  //     res[2] ? res[2].value || res[2].id : ''
  //   ]
  // }

  // 编辑赋值
  assignFormdata() {
    this.editId = this.editForm.id
    const editIssueType: any = [
      this.editForm.location.place_id,
      this.editForm.location.building_id,
      this.editForm.location.floor_id
    ]
    this.formData = {
      tutorName: this.editForm.creator.name,
      issueDate: this.editForm.create_time.split(' ')[0],
      // is_use_office_network: this.editForm.is_use_office_network,
      location: editIssueType,
      position: this.editForm.position,
      describe: this.editForm.describe,
      // problem_type: this.editForm.problem_type,
      remark: this.editForm.remark,
      fileList: [
        {
          name: '回显',
          image_url: this.editForm.remark
        }
      ]

      // is_living: this.editForm.is_living,
    }
    this.liveIssueCn =
      this.editForm.location.place +
      '/' +
      this.editForm.location.building +
      '/' +
      this.editForm.location.floor
  }

  handleSubmit(formName: string) {
    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'addIssue'
        await (CGGLISISSUESAPI as any)
          // eslint-disable-next-line no-unexpected-multiline
          [action](
            this.formData.remark
              ? {
                location: Number(this.formData.location[2].split('_')[1]),
                describe: this.formData.describe,
                position: this.formData.position,
                // problem_type: this.formData.problem_type[1],
                remark: this.formData.remark
              }
              : {
                location: Number(this.formData.location[2].split('_')[1]),
                describe: this.formData.describe,
                position: this.formData.position
                // problem_type: this.formData.problem_type[1]
              },
            {
              app_id: this.userCurrentApp
            }
          )
          .then((res: any) => {
            if (res.stat === 1) {
              this.$message.success('提交成功')
              this.handleResetForm(formName)
              this.$router.push({ path: '/home' })
            }
            this.isDisableSubmit = false
          })
          .catch(() => {
            this.isDisableSubmit = false
          })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  // handleRemove(file: any, fileList: any) {
  //   console.log(file, fileList);
  // }
  // handlePreview(file) {
  //   console.log(file);
  // }
  handleExceed(files: any, fileList: any) {
    this.$message.warning(
      `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
      } 个文件`
    )
  }

  beforeRemove(file: any) {
    return this.$confirm(`确定移除 ${file.name}？`)
  }

  handleSuccess(res: any) {
    if (res.stat === 1) {
      this.formData.remark = res.data.image_url
    }
  }

  handleEditSubmit(formName: string) {
    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'editIssue'
        await (CGGLISISSUESAPI as any)
          // eslint-disable-next-line no-unexpected-multiline
          [action]({
            id: this.editId,
            location: Number(this.formData.location[2].split('_')[1]),
            describe: this.formData.describe,
            position: this.formData.position
            // problem_type: this.formData.problem_type[1]
            // remark: this.formData.remark,
          })
          .then((res: any) => {
            if (res.stat === 1) {
              this.$emit('handleSuccess', res)
              this.$emit('handleCloseDialog')
            }
            this.isDisableSubmit = false
          })
          .catch(() => {
            this.isDisableSubmit = false
          })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.liveIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    const form: any = this.$refs[formName]
    form.resetFields()
    this.formData.location = [0, 0, 0]
  }
}
